import React, { FC, useCallback } from 'react';
import { Button, Col, FormGroup, Input, Label, ModalBody, ModalFooter, Row } from 'reactstrap';
import { PreviousYearAttendanceCriterionOptions } from '../../../../../shared/orders/raffle';
import { Breadcrumb, InlineHelp } from '../../../../components';
import { MaterialIconText } from '../../../../components/MaterialIconText';
import { useTranslation } from '../../../../translations';
import { useNumericInputState } from '../../../../utils';
import { RaffleConfiguratorProps } from '../utils';

export const PrevYearsAttended: FC<
  RaffleConfiguratorProps<PreviousYearAttendanceCriterionOptions>
> = ({ defaultOptions, displayName, onBack, onCancel, onConfigure }) => {
  const { ts } = useTranslation();
  const [previousYears, setPreviousYears] = useNumericInputState(
    defaultOptions?.previousYears ?? 0,
  );

  const onFinish = useCallback(() => {
    onConfigure({ name: 'prevYearAttendance', options: { previousYears } });
  }, [onConfigure, previousYears]);

  return (
    <>
      <ModalBody>
        <Row>
          <Col xs={12}>
            <Breadcrumb
              items={[
                { text: `${ts('common.display_name')}: ${displayName ?? 'None'}` },
                { text: `${ts('type')}: Previous Years Attended` },
              ]}
            />
            <MaterialIconText name="keyboard_backspace" onClick={onBack}>
              {ts('common.go_back')}
            </MaterialIconText>
            <hr />
          </Col>
          <Col xs={12}>
            <FormGroup>
              <Label for="value">
                {ts('maximum_number_of_years')}
                <InlineHelp>
                  <p>
                    {ts(
                      // eslint-disable-next-line max-len
                      'this_sets_the_maximum_number_of_years_that_will_be_taken_into_account_for_how_long_the_attendee_has_attended_in_calculations_this_is_represented_by_a_number_from__to_the_maximum',
                    )}
                  </p>
                  <p>
                    {ts(
                      'for_example_if_the_maximum_is_set_to__three_then_an_attendee_with__five_years_attendance_will_only_have__three_of_those_counted',
                    )}
                  </p>
                </InlineHelp>
              </Label>
              <Input
                id="value"
                name="value"
                onChange={setPreviousYears}
                required
                type="number"
                value={previousYears}
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button
          className="editor-finish-btn"
          color="primary"
          disabled={!previousYears || previousYears <= 0}
          onClick={onFinish}
        >
          {ts('common.finish')}
        </Button>
        <Button className="editor-cancel-btn" color="secondary" onClick={onCancel} outline>
          {ts('common.cancel')}
        </Button>
      </ModalFooter>
    </>
  );
};
